export default {
  banks: [],
  bank: {}
}
